/**
 * DOM markers so Ask Chckvet can snapshot the page without the dock
 * or a full HTML dump.
 */
export const ASK_CHCKVET_MAIN_ATTR = 'data-ask-chckvet-main'
export const ASK_CHCKVET_DOCK_ATTR = 'data-ask-chckvet-dock'
